import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";

function CustomTabs({ label, index, activeStep, changeStep, renderInfo, disabled }) {
    const matches = useMediaQuery("(min-width:960px)");
    return (
        <Step
            key={label}
            onClick={disabled ? undefined : () => changeStep(index)}
            activeStep={activeStep}
            index={index}
            style={{
                transition: "0.2s",
                cursor: disabled ? "not-allowed" : "pointer",
                alignItems: matches ? "flex-start" : "center",
            }}
        >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <label.icon sx={{ marginRight: matches ? 1 : 0 }} color={activeStep >= index ? "primary" : "secondary"} />
                <Box>
                    {matches && (
                        <Typography variant="h5" fontSize={19} color={activeStep >= index ? "primary" : "secondary"} style={{ transition: "0.2s" }}>
                            {label.nom}
                        </Typography>
                    )}
                    {renderInfo && <Typography variant="caption">{renderInfo(index)}</Typography>}
                </Box>
            </Box>
        </Step>
    );
}

export default CustomTabs;

const Step = styled(Box)(({ theme, activeStep, index }) => ({
    borderBottom: activeStep >= index ? "3px solid " + theme.palette.primary.main : "3px solid " + theme.palette.secondary.main,
    borderTop: activeStep >= index ? "1px solid " + theme.palette.primary.main : "1px solid " + theme.palette.secondary.main,
    backgroundColor: "transparent",
    borderLeft: activeStep >= index ? "1px solid " + theme.palette.primary.main : "1px solid " + theme.palette.secondary.main,
    borderRight: activeStep >= index ? "1px solid " + theme.palette.primary.main : "1px solid " + theme.palette.secondary.main,
    padding: 15,
    opacity: activeStep >= index ? 1 : 0.7,
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: 10,
    margin: 5,
}));
